import { render } from "./MinimumPrice.vue?vue&type=template&id=2aafddde&lang=pug"
import script from "./MinimumPrice.vue?vue&type=script&lang=js"
export * from "./MinimumPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__